<template>
  <b-container fluid>
    <b-row>
        <b-col>
            <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
            <vue-cal
                style="height: 550px"
                active-view="week"
                :disable-views="['years', 'year']"
                today-button
                :time="false"
                events-on-month-view="short"
                locale="es"
                 selected-date="2021-06-23"
                :events="eventsList"
            />
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import moment from "moment"
import axios from 'axios'
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import 'vue-cal/dist/i18n/es.js'

export default {
  name: 'App',
  components: {
    VueCal
  },
  data () {
    return {
        loading: false,
        eventsList: []
    }
  },
  props: {
      calendarData: {
          type: Array,
          default: []
      },
  },
  methods: {
    getCompetitions () {
      axios.get('https://us-central1-atpro-app.cloudfunctions.net/api/competitions/all')
        .then(r => {
        //   console.log('✅ Get Competitions', r.data.data)

          this.scheduleList = r.data.data.map(e => {
            // console.log(moment(new Date(e.item.date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"));
            return new Event({
              id: e.key,
              calendarId: "8",
              title: e.item.name,
              body: e.item.name,
              isAllday: true,
              start:
                moment(new Date(e.item.date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"),
              end:
                moment(new Date(e.item.date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD"),
              category: "allday",
              isReadOnly: true,
              location: e.item.city + " " + e.item.country
            })
          })
        })
        .catch(e => {
          console.error('Error Competitions', e)
          this.loading = false;
        })
    }
  },
  mounted () {
    core.index();
    
    this.$bus.$on('routinesData', (data) => {
        // this.loading = true;
        let Events = [];
        try {
          data.forEach(async e => {
              let eventDate = moment(new Date(e.routine_date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD");
              this.eventsList.push({
                  start: eventDate,
                  end: eventDate,
                  title: `R: ${e.name}`,
                  // content: `<i class="v-icon material-icons">Ritmo Cardiaco: ${e.heart_rate}</i>`,
                  class: 'routine'
              });
              this.loading = false;
          })
          if(data.length == 0){
              this.loading = false;
          }
        } catch (error) {
          console.error(error)
          this.loading = false;
        }
    });

    this.$bus.$on('testsData', (data) => {
      try {
        // this.loading = true;
        let Events = [];
        data.forEach(e => {
            let testDate = moment(new Date(e.item.activity_date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD");
            this.eventsList.push({
                start: testDate,
                end: testDate,
                title: `T: ${e.item.test_name}`,
                // content: `<i class="v-icon material-icons">Ritmo Cardiaco:</i>`,
                class: 'test'
            });
            this.loading = false;
        })
        if(data.length == 0){
            this.loading = false;
        }
      } catch (error) {
          console.error(error)
          this.loading = false;
      }
    });

    this.$bus.$on('competitionData', (data) => {
      try {
        // this.loading = true;
        let Events = [];
        data.forEach(e => {
            let competitionDate = moment(new Date(e.competition_date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD");
            this.eventsList.push({
                start: competitionDate,
                end: competitionDate,
                title: `C: ${e.competition_info.name}`,
                // content: `<i class="v-icon material-icons">Ritmo Cardiaco:</i>`,
                class: 'competition'
            });
            this.loading = false;
        })
        if(data.length == 0){
            this.loading = false;
        }
      } catch (error) {
        console.error(error)
          this.loading = false;
      }
    });
  }
}
</script>
<style>
.vuecal__event.test {background-color: lightblue;border: 1px solid darkblue;}
.vuecal__event.competition {background-color: lightgreen;border: 1px solid darkgreen;}
.vuecal__event.routine {background-color: rgba(255, 102, 102, 0.9);border: 1px solid rgb(235, 82, 82);color: #fff;}
.vuecal__cell--has-events {background-color: #fffacd;}
.vuecal__cell-events-count {display: none;}
.vuecal--month-view .vuecal__cell {height: 80px;}

.vuecal--month-view .vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
}

.vuecal--month-view .vuecal__cell-date {padding: 4px;}
.vuecal--month-view .vuecal__no-event {display: none;}
</style>